module.exports = __webpack_public_path__ + "/assets/img/ef0be6cc9cf17ee41437b64229ce6b72.jpg";